/** Подписи ролей в UI панели сотрудников */
const LABELS: Record<string, string> = {
  admin: 'Администратор',
  tech: 'Техник',
  manager: 'Менеджер',
};

export function staffRoleLabel(role: string): string {
  return LABELS[role] ?? role;
}

/** Короткие подписи (аудит договоров и т.п.) */
export function staffRoleShort(role: string): string {
  if (role === 'admin') return 'админ';
  if (role === 'tech') return 'техн.';
  if (role === 'manager') return 'менедж.';
  return role;
}
